import { useMutation, useQuery } from '@tanstack/react-query';
import axiosInstance from './axios';
import { SalesInvoiceResponse } from '../types/salesReturn';

export const useGetAllSalesReturn = (postData: {
  pageNo: number;
  pageSize: number;
  salesReturnNumber?: string | number;
  // enableFlag?: boolean;
}) => {
  return useQuery({
    queryKey: ['useGetAllSalesReturn', postData],
    queryFn: async () => {
      const { data } = await axiosInstance.post(
        `/sales/invoice/return/all`,
        postData
      );
      return data;
    },
    // enabled: postData.enableFlag,
  });
};

// GET: Fetch sales invoice details by invoice ID
export const useGetASalesReturnEntry = (invoiceId: string) => {
  return useQuery({
    queryKey: ['useGetASalesReturnEntry', invoiceId],
    queryFn: async () => {
      const { data } = await axiosInstance.get(`/sales/invoice/${invoiceId}`);
      return data as SalesInvoiceResponse;
    },
    enabled: !!invoiceId,
  });
};

// POST: Save sales invoice details
export const useSaveSalesInvoice = () => {
  return useMutation({
    mutationKey: ['useSaveSalesInvoice'],
    mutationFn: async (postData: any) => {
      const { data } = await axiosInstance.post(
        'sales/invoice/return',
        postData
      );
      return data as any;
    },
  });
};

// GET: Fetch sales return detail by ID
export const useGetSalesReturnDetail = (returnId: string | number | null) => {
  return useQuery({
    queryKey: ['useGetSalesReturnDetail', returnId],
    queryFn: async () => {
      const { data } = await axiosInstance.get(
        `/sales/invoice/return/${returnId}`
      );
      return data as any;
    },
    enabled: !!returnId,
  });
};
